import Container from '../../../utils/Container'
import Paragraph from '../../../elements/p/Paragraph'
import location from '../../../../medias/svg/location.svg'
import phone from '../../../../medias/svg/phone.svg'
import mail from '../../../../medias/svg/mail.svg'

import revisionImg from '../../../../medias/svg/revision.svg'


const ContactInfo = () => {
		return(  
			<Container classe="mt-28 md:mt-32 flex flex-col sm:flex-row space-y-20 sm:space-y-0 sm:space-x-5 justify-between lg:justify-around items-center">
				<div className="relative w-28 md:w-72 lg:w-64">
					<img src={location} alt="traduction" className="w-10 md:w-14" />
					<div className="sm:absolute -bottom-14 right-0">
						<Paragraph>Cameroun</Paragraph>
					</div>
				</div>

				<div className="relative w-28 md:w-72 lg:w-64">
					<img src={phone} alt="traduction" className="w-14 md:w-18" />
					<div className="sm:absolute -bottom-10 right-0">
						<Paragraph>Téléphone</Paragraph>
						<Paragraph>+237 6 91 00 07 82</Paragraph>
					</div>
				</div>

				<div className="relative w-28 md:w-72 lg:w-64">
					<img src={mail} alt="traduction" className="w-14 md:w-18" />
					<div className="sm:absolute -bottom-10 right-0">
						<Paragraph>Email</Paragraph>
						<Paragraph>rita.nsangou@yahoo.com</Paragraph>
					</div>
				</div>
			</Container>
	)
}

export default ContactInfo